<script lang="ts">
    import { _ } from 'svelte-i18n';
    import OneNumber from './OneNumber.svelte';
    import { daysInEnglishShort } from '../../../utilities/Weekdays';

    export let daysOfWeek: number[] = [];
    export let onChange: (daysOfWeek: number[]) => void;
    export let disabled: boolean = false;
</script>

<div class="days-of-week-container">
    {#each [1, 2, 3, 4, 5, 6, 0] as day}
        <OneNumber
            value={day}
            title={$_(daysInEnglishShort[day])}
            isSelected={daysOfWeek.includes(day)}
            {disabled}
            onChange={() => {
                if (daysOfWeek.includes(day)) {
                    onChange(daysOfWeek.filter(d => d !== day));
                } else {
                    onChange([...daysOfWeek, day]);
                }
            }}
        />
    {/each}
</div>

<style>
    .days-of-week-container {
        display: flex;
        flex-wrap: wrap;
        column-gap: 2px;
        row-gap: 2px;
    }
</style>
